export default {"src":"/_next/static/media/ComplianceProDark.6a2ed3ee.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};